"use strict";

var _classCallCheck = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hmac = void 0;

var _assert_js_1 = require("./_assert.js");

var utils_js_1 = require("./utils.js"); // HMAC (RFC 2104)


var HMAC = /*#__PURE__*/function (_utils_js_1$Hash) {
  _inherits(HMAC, _utils_js_1$Hash);

  var _super = _createSuper(HMAC);

  function HMAC(hash, _key) {
    var _this;

    _classCallCheck(this, HMAC);

    _this = _super.call(this);
    _this.finished = false;
    _this.destroyed = false;

    _assert_js_1.default.hash(hash);

    var key = (0, utils_js_1.toBytes)(_key);
    _this.iHash = hash.create();
    if (!(_this.iHash instanceof utils_js_1.Hash)) throw new TypeError('Expected instance of class which extends utils.Hash');
    var blockLen = _this.blockLen = _this.iHash.blockLen;
    _this.outputLen = _this.iHash.outputLen;
    var pad = new Uint8Array(blockLen); // blockLen can be bigger than outputLen

    pad.set(key.length > _this.iHash.blockLen ? hash.create().update(key).digest() : key);

    for (var i = 0; i < pad.length; i++) {
      pad[i] ^= 0x36;
    }

    _this.iHash.update(pad); // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone


    _this.oHash = hash.create(); // Undo internal XOR && apply outer XOR

    for (var _i = 0; _i < pad.length; _i++) {
      pad[_i] ^= 0x36 ^ 0x5c;
    }

    _this.oHash.update(pad);

    pad.fill(0);
    return _this;
  }

  _createClass(HMAC, [{
    key: "update",
    value: function update(buf) {
      _assert_js_1.default.exists(this);

      this.iHash.update(buf);
      return this;
    }
  }, {
    key: "digestInto",
    value: function digestInto(out) {
      _assert_js_1.default.exists(this);

      _assert_js_1.default.bytes(out, this.outputLen);

      this.finished = true;
      this.iHash.digestInto(out);
      this.oHash.update(out);
      this.oHash.digestInto(out);
      this.destroy();
    }
  }, {
    key: "digest",
    value: function digest() {
      var out = new Uint8Array(this.oHash.outputLen);
      this.digestInto(out);
      return out;
    }
  }, {
    key: "_cloneInto",
    value: function _cloneInto(to) {
      // Create new instance without calling constructor since key already in state and we don't know it.
      to || (to = Object.create(Object.getPrototypeOf(this), {}));
      var oHash = this.oHash,
          iHash = this.iHash,
          finished = this.finished,
          destroyed = this.destroyed,
          blockLen = this.blockLen,
          outputLen = this.outputLen;
      to = to;
      to.finished = finished;
      to.destroyed = destroyed;
      to.blockLen = blockLen;
      to.outputLen = outputLen;
      to.oHash = oHash._cloneInto(to.oHash);
      to.iHash = iHash._cloneInto(to.iHash);
      return to;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
      this.oHash.destroy();
      this.iHash.destroy();
    }
  }]);

  return HMAC;
}(utils_js_1.Hash);
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */


var hmac = function hmac(hash, key, message) {
  return new HMAC(hash, key).update(message).digest();
};

exports.hmac = hmac;

exports.hmac.create = function (hash, key) {
  return new HMAC(hash, key);
};